import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";

import "./HairBuffer.css";

const leftData = [
  {
    file: "01",
    text: "Create your hair profile"
  },
  {
    file: "02",
    text: "View hair products that target your needs"
  },
  {
    file: "03",
    text: "Purchase what you love at trusted retailers"
  }
];

class HairBuffer extends Component {
  renderSteps = () => {
    return leftData.map((row, ind) => {
      return (
        <div
          className={`hair-buffer__body-message-row hair-buffer__body-message-row__row-${ind +
            1}`}
        >
          <div className="hair-buffer__body-message-image-container">
            <img
              className="hair-buffer__body-message-image"
              src={`/images/explain/section2/${row.file}.png`}
            />
          </div>
          <div className="hair-buffer__body-message-message-container">
            <h3 className="hair-buffer__body-message-message">{row.text}</h3>
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <div className="hair-buffer">
        <Helmet>
          <title>Discover Products For Your Unique Hair Needs - HelloAva</title>
        </Helmet>
        <div className="hair-buffer__header-section">
          <h1 className="hair-buffer__header">
            Discover the best products for your unique hair needs
          </h1>
        </div>
        <div className="hair-buffer__body-container">
          <div className="hair-buffer__body-section hair-buffer__body-section__left-section">
            {this.renderSteps()}
          </div>
          <div className="hair-buffer__body-section hair-buffer__body-section__right-section">
            <div className="hair-buffer__body-section-button-container">
              <a href="/hair/onboarding">
                <button className="hair-buffer__body-section-button">
                  {localStorage.getItem("user_has_hair_profile")
                    ? "Retake Hair Quiz"
                    : "Start Hair Quiz"}
                </button>
              </a>
              {!localStorage.getItem("user_id") && <div>or</div>}
              {!localStorage.getItem("user_id") && (
                <div className="hair-buffer__body-section-login">
                  <a
                    onClick={() => {
                      localStorage.setItem("from_hair_buffer", true);
                    }}
                    href="/signin"
                    className="hair-buffer__body-section-login-link"
                  >
                    Log in
                  </a>{" "}
                  to your profile
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(HairBuffer);



// WEBPACK FOOTER //
// ./src/views/hair/buffer/HairBuffer.js